export const networkTypeOptions = [
  { value: '', label: '전체' },
  { value: 'LTE', label: 'LTE' },
  { value: 'ETHERNET', label: 'ETHERNET' },
  { value: 'WIFI', label: 'WIFI' },
  { value: 'ETC', label: 'ETC' },
];

export const linkTypeOptions = [
  { value: 'T-232ISO-LINK', label: 'T-232ISO-LINK' },
  { value: 'T-485ISO-LINK', label: 'T-485ISO-LINK' },
  { value: 'T-485ISO-V1-LINK', label: 'T-485ISO-V1-LINK' },
  { value: 'T-AC-AMPERE-LINK', label: 'T-AC-AMPERE-LINK' },
  { value: 'T-AC-INPUT-LINK', label: 'T-AC-INPUT-LINK' },
  { value: 'T-CATM1-LINK', label: 'T-CATM1-LINK' },
  { value: 'T-ETHERNET-V1-LINK', label: 'T-ETHERNET-V1-LINK' },
  { value: 'T-ETHERNET-LINK', label: 'T-ETHERNET-LINK' },
  { value: 'T-INPUT-LINK', label: 'T-INPUT-LINK' },
  { value: 'T-NTCISO-LINK', label: 'T-NTCISO-LINK' },
  { value: 'T-NTC-LINK', label: 'T-NTC-LINK' },
  { value: 'T-PT100ISO-LINK', label: 'T-PT100ISO-LINK' },
  { value: 'T-PT100-LINK', label: 'T-PT100-LINK' },
  { value: 'T-RELAY-LINK', label: 'T-RELAY-LINK' },
  { value: 'T-SENSOR-INPUT-LINK', label: 'T-SENSOR-INPUT-LINK' },
];

export const modemTypeOptions = [
  { value: 'BM5', label: 'BM5' },
  { value: 'LM5', label: 'LM5' },
  { value: 'LM6', label: 'LM6' },
  { value: 'LCM300', label: 'LCM300' },
  { value: 'LCM801V', label: 'LCM801V' },
  { value: 'RUT241', label: 'RUT241' },
  { value: 'ETC', label: '기타' },
];

export const modelStatusOptions = [
  { value: 'Y', label: '사용중' },
  { value: 'N', label: '회수' },
];

export const telecomProviderOptions = [
  { value: 'SKT', label: 'SKT' },
  { value: 'KT', label: 'KT' },
  { value: 'LG U+', label: 'LG U+' },
  { value: 'Global', label: 'Global USIM' },
];

export const telecomPlanOptionsByProvider: { [key: string]: { value: string; label: string }[] } = {
  SKT: [
    { value: 'LTE-M-10', label: 'LTE-M-10' },
    { value: 'LTE-M-40', label: 'LTE-M-40' },
    { value: 'LTE-M-50', label: 'LTE-M-50' },
    { value: 'IoT 모니터링 라이트', label: 'IoT 모니터링 라이트' },
  ],
  KT: [
    { value: 'IoT38', label: 'IoT38' },
    { value: 'IoT77', label: 'IoT77' },
    { value: 'IoT110', label: 'IoT110' },
    { value: 'IoT165', label: 'IoT165' },
    { value: 'IoT 안심 데이터 275', label: 'IoT 안심 데이터 275' },
    { value: '순비즈10GB', label: '순비즈10GB' },
  ],
  Global: [{ value: '1NCE', label: '1NCE' }],
};

export const activationStatusOptions = [
  { value: 'PENDING', label: '진행 전' },
  { value: 'INPROGRESS', label: '진행 중' },
  { value: 'COMPLETED', label: '개통 완료' },
  { value: 'FAILED', label: '막힘' },
  { value: 'CANCELED', label: '해지' },
];
